import { render, staticRenderFns } from "./New-Home.vue?vue&type=template&id=0d095acc"
import script from "./New-Home.vue?vue&type=script&lang=js"
export * from "./New-Home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports